import {
  IonAccordion,
  IonAccordionGroup,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonChip,
  IonItem,
} from "@ionic/react";
import { useEffect, useState } from "react";
import { makeGETRequest } from "../../../request/rawRequest";

interface Props {
  pole: number;
  type: string;
}

interface ThemeStat {
  name: string;
  quizzAvg: string;
  quizzTries: number[];
  synthesisAvg: string;
  synthesisTries: number[];
}

interface SkillStat {
  name: string;
  _id: string;
  isLoad: boolean;
  themes: ThemeStat[];
}

export const getAverage = (array: number[]): string => {
  let sum = 0;
  for (const mark of array) {
    sum += mark;
  }
  if (sum === 0) {
    return "Pas encore effectué";
  }
  return (sum / array.length).toFixed(2);
};

const StatsPoleTechnologie: React.FC<Props> = ({ pole, type }) => {
  const [skills, setSkills] = useState<SkillStat[]>([]);
  const [userEmail, setUserEmail] = useState<string>("");
  const [fetch, setFetch] = useState<boolean>(false);

  useEffect(() => {
    makeGETRequest("/me").then((res) => {
      setUserEmail(res.email);
    });

    makeGETRequest(
      `/stats/skills?genre=technology&pole=${pole}&type=${type}`
    ).then((res) => {
      for (const skill of res) {
        setSkills((old) => [
          ...old,
          {
            name: skill.skill_name,
            _id: skill.id_skills,
            isLoad: false,
            themes: [],
          },
        ]);
      }
    });
  }, []);

  if (skills.length <= 0) return null;

  return (
    <IonAccordionGroup>
      {skills?.map((skill, i) => {
        return (
          <IonAccordion
            key={i}
            onClick={() => {
              if (skill.isLoad === false) {
                setFetch(true);
                makeGETRequest(
                  `/stats/details/technology?id_skills=${skill._id}&email=${userEmail}`
                ).then((res) => {
                  for (const videoDetail of res.videoDetails) {
                    const { quizz_mark, synthesis_mark, video_name } =
                      videoDetail;

                    const quizzAvg = getAverage(quizz_mark);
                    const synthesisAvg = getAverage(synthesis_mark);
                    setSkills((old) => [
                      ...old.slice(0, i),
                      {
                        ...old[i],
                        isLoad: true,
                        themes: [
                          ...old[i].themes,
                          {
                            name: video_name,
                            quizzAvg,
                            quizzTries: quizz_mark,
                            synthesisAvg,
                            synthesisTries: synthesis_mark,
                          },
                        ],
                      },
                      ...old.slice(i + 1, old.length),
                    ]);
                    setFetch(false);
                  }
                });
              }
            }}
          >
            <IonItem
              className="border-secondary"
              style={{
                borderRadius: 20,
                margin: "5px 0 5px 0",
              }}
              slot="header"
            >
              {skill.name}
            </IonItem>
            <div slot="content">
              {fetch === true ? (
                <div>Chargement ....</div>
              ) : (
                skill.themes.map((theme, j) => {
                  return (
                    <IonCard key={j}>
                      <IonCardHeader>
                        <IonCardTitle>{theme.name}</IonCardTitle>
                      </IonCardHeader>

                      <IonCardContent>
                        <IonItem>
                          moyenne pour le quizz : {theme.quizzAvg}
                        </IonItem>
                        {theme.quizzTries &&
                          theme.quizzTries.map((mark, markIndex) => (
                            <IonChip
                              color="secondary"
                              outline={true}
                              key={markIndex}
                            >
                              {mark}
                            </IonChip>
                          ))}
                        <IonItem>
                          moyenne pour la synthèse : {theme.synthesisAvg}
                        </IonItem>
                        {theme.synthesisTries &&
                          theme.synthesisTries.map((mark, markIndex) => (
                            <IonChip
                              color="secondary"
                              outline={true}
                              key={markIndex}
                            >
                              {mark}
                            </IonChip>
                          ))}
                      </IonCardContent>
                    </IonCard>
                  );
                })
              )}
            </div>
          </IonAccordion>
        );
      })}
    </IonAccordionGroup>
  );
};

export default StatsPoleTechnologie;
